import './style.css'
import Slider from "../Slider";

export default class PeopleSlider {
    static selector = '.people-slider'

    constructor(block) {
        this.block = block;

        this.sliderContainer = this.block.querySelector('#people-slider');

        this.bioActionButtons = Array.from(this.block.querySelectorAll('.people-slider__bio-action'));
        this.bioCloseActionButtons = Array.from(this.block.querySelectorAll('.people-slider__close-bio'));

        this.bioActionButtons
            .forEach(action => action.addEventListener('click', this.onBioActionClick.bind(this)), false);

        this.bioCloseActionButtons
            .forEach(action => action.addEventListener('click', this.onBioActionClick.bind(this)), false);
    }

    onComplete() {
        new Slider({
            container: this.sliderContainer,
            controlsContainer: this.block.querySelector('.people-slider__nav'),
            gutter: 20,
            fixedWidth: 270,
            preventScrollOnTouch: 'auto',
            onInit: () => {
              this.sliderContainer.classList.remove('is-hidden');
            },
            responsive: {
                765: {
                    fixedWidth: false,
                    items: 2,
                    gutter: 30,
                },
                1025: {
                    gutter: 40,
                    autoplay: true,
                    autoplayButton: false,
                    items: 4,
                }
            }
        })
    }

    onBioActionClick(e) {
        e.stopPropagation();
        const closestPerson = e.target
            .closest('.people-slider__person');
        const bio = closestPerson
            .querySelector('.people-slider__bio');
        const bioActionBtn = closestPerson
            .querySelector('.people-slider__bio-action');

        const isOpen = bio.classList.contains('is-open');
        const { textClose, textOpen } = bioActionBtn.dataset;

        bioActionBtn.innerText = isOpen ? textOpen : textClose;
        bio.classList.toggle('is-open');
    }
}
